import { FormFeedback, FormFeedbackProps } from "reactstrap";

/**
 * This is a FormFeedback which doesn't attach to a form input.
 */

interface InlineFeedbackProps extends FormFeedbackProps {
  children: React.ReactNode;
}

const InlineFeedback = (props: InlineFeedbackProps) => {
  const { children, className, ...feedbackProps } = props;

  return (
    <FormFeedback {...feedbackProps} invalid={(!!feedbackProps.invalid).toString()}
      className={`${className} ${(feedbackProps.valid || feedbackProps.invalid) && 'd-block pre-wrap'}`}>
      {children}
    </FormFeedback>
  );
};

export default InlineFeedback;
